// extracted by css-extract-rspack-plugin
export default {"wilsonShell":"wilsonShell-hEhF1c","wilsonLogo":"wilsonLogo-vVrGn2","wilsonBody":"wilsonBody-dylzOU","wilsonForm":"wilsonForm-qng8AA"};